<div class="type-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
